import React, { Component } from 'react'
import { ChatListTheme } from 'modules/theme'

export class ChatList extends Component {
  render() {
    return (
      <ChatListTheme
        title={'Chat List'}
        search={''}
        btnSearch={'images/search.svg'}
      />
    )
  }
}

export default ChatList


// WEBPACK FOOTER //
// src/dialpad/components/layout/ChatList.js